import { ProfileSettingsService } from './../../services/shared/profile-settings/profile-settings.service';
import { environment } from 'src/environments/environment';
import { Component, OnInit, Inject, Pipe, PipeTransform, ChangeDetectorRef, Input, ElementRef, ViewChild } from '@angular/core';
import { LoginService } from 'src/app/services/login/login.service';
import { SocialMediaService } from 'src/app/services/social-media/social-media.service';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl, Validators, FormGroupDirective, NgForm, FormControl } from '@angular/forms';
import { SessionService } from 'src/app/services/session/session.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ErrorStateMatcher } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

import { MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig } from '@angular/material/dialog';
import { SignUpDetails } from 'src/app/classes/login/sign-up';
import { Session } from 'src/app/classes/session/session';
import { LoaderService } from '../loader/services/loader/loader.service';
import { MessageService } from 'src/app/services/message/message.service';
import { jsonParse, cloneArray } from '../../app.component';
import { prepareSections, prepareSectionData, checkActiveSection, findInvalidControls } from 'src/app/controls/components/dynamic-form/dynamic-form.component';
import { TranslateService } from '@ngx-translate/core';
import { NotificationService } from '../../services/shared/notification/notification.service';
import { ConfirmationComponentCopy } from '../confirmation-copy/confirmation.component';
import { WorkbenchService } from '../../services/workbench.service';
import { ConfirmationComponent } from '../shared/confirmation/confirmation.component';
import { DeviceDetectorService } from "ngx-device-detector";
import { ForgotPasswordComponent } from '../login/components/forgot-password/forgot-password.component';
import { getInvalidFields, prepareFieldConfigFlagsNew } from 'src/app/functions/shared-functions';
import { markFormGroupTouched } from 'src/app/controls/functions/shared-functions';
class CrossFieldErrorMatcher implements ErrorStateMatcher {
  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    return control.dirty && form.invalid;
  }
}
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  providers: [LoginService, SocialMediaService, WorkbenchService]
})

export class LoginComponentV2 implements OnInit {
  sign_up_details = new SignUpDetails();
  public loading = 0;
  error_message: string;
  isd;
  skill_code;
  search: string;
  message;
  session = new Session();
  length_file;


  isOTPSendSuccessfully = false;
  resetPasswordRequest = false;
  isOTPVariedSuccessfully = false;
  userId;
  OTP;
  newPassword;

  isLoaded = false;
  isSubmitted = false;
  userPostResData;
  isChangePasswordClicked = false;
  userValid;
  userLogin = false;
  forgetPassword = false;
  isLinkSendSuccessfully = true;
  invalid = false;
  password_form: UntypedFormGroup;
  errorMatcher = new CrossFieldErrorMatcher();
  dynamic_form: UntypedFormGroup | any = {};
  display_type: number;
  section_data;
  masters = [];
  hides_2;
  hide;
  hides_1;
  parsed_resume;
  @Input() CellClicked;
  callbackFuncRef;
  is_mobile_number: boolean;
  mobileNumber: any;
  emailId: any;
  employeeId: any;
  email_pattern1 = "^[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}$";
  valid_captcha: any;
  valid_captcha_flag: boolean;
  @ViewChild('recaptcha', { static: true }) captch_element: ElementRef;
  authType: any;
  passValidation = {
    mandatory: 1,
  }
  otp_send = 0;
  timer;
  field_config_access: any = {}
  constructor(
    private loginService: LoginService,
    private sm_service: SocialMediaService,
    private formBuilder: UntypedFormBuilder,
    private session_service: SessionService,
    private router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private _snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<LoginComponentV2>,
    @Inject(MAT_DIALOG_DATA) public data,
    private message_service: MessageService,
    private loader: LoaderService,
    private notification_svc: NotificationService,
    private change_detector: ChangeDetectorRef,
    private translate: TranslateService,
    private workbench_svc: WorkbenchService,
    private device_detector_srv: DeviceDetectorService,
    private profile_svc: ProfileSettingsService

  ) {
    this.dynamic_form = new UntypedFormGroup({});
  }

  form_flag = 1;

  social_media: any = [];

  signup_form: UntypedFormGroup;
  login_form: UntypedFormGroup;
  init() {
    this.dynamic_form = new UntypedFormGroup({});

    this.password_form = new UntypedFormGroup(
      {
        login_id: new UntypedFormControl("", Validators.required),

      }
    );
    this.login_form = new UntypedFormGroup(
      {
        loginId: new UntypedFormControl(null, [Validators.required]),
        password: new UntypedFormControl(null, Validators.required),
        otp: new FormControl(null)
      });
    this.login_form.controls.loginId.valueChanges.subscribe(res => {
      let a: string = res;

      if (res) {
        let form: UntypedFormGroup = new UntypedFormGroup({
          emailId: new UntypedFormControl(null, [Validators.pattern(this.email_pattern1)]),
          mobileNumber: new UntypedFormControl(null, [Validators.pattern('^[0-9]*$')])
        })
        form.controls.emailId.patchValue(res);
        form.controls.mobileNumber.patchValue(res);
        if (form.controls.mobileNumber.valid) {
          this.is_mobile_number = true;
          this.mobileNumber = res;
          this.emailId = null;
          this.employeeId = null;

        }
        else if (form.controls.emailId.valid) {
          this.is_mobile_number = false;
          this.mobileNumber = null;
          this.emailId = res;
          this.employeeId = null
        }
        else {
          this.is_mobile_number = false;
          this.mobileNumber = null;
          this.emailId = null;
          this.employeeId = res
        }
      }
      else {
        this.is_mobile_number = false;
      }

      try {
        this.change_detector.detectChanges();
      }
      catch (err) {

      }


      // if (a.charCodeAt(0) >= 48 && a.charCodeAt(0) <= 57) {
      //   this.is_mobile_number = true;
      // }
      // else {
      //   this.max_length = 100;
      //   this.is_mobile_number = false;
      //   // try {
      //   //   this.change_detector.detectChanges();
      //   // }
      //   // catch (err) {
      //   //
      //   // }
      // }
    })
    this.signup_form = new UntypedFormGroup(
      {
        // first_name: new FormControl('', Validators.required),
        password: new UntypedFormControl(null, Validators.required),
        // last_name: new FormControl(''),
        // email_id: new FormControl('', [Validators.required, Validators.pattern(/^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-z]{2,4}|[0-9]{1,3})(\]?)$/)]),
        confirm_password: new UntypedFormControl(null, Validators.required),
        // isd: new FormControl(1001, Validators.required),
        // mobile_number: new FormControl('', Validators.required),
        // experience: new FormControl(null),
        // skill_code: new FormControl([])
      }, {
      validators: this.passwordValidator
    });

  }
  email_pattern(email_pattern: any): import("@angular/forms").ValidatorFn | import("@angular/forms").ValidatorFn[] | import("@angular/forms").AbstractControlOptions {
    throw new Error('Method not implemented.');
  }
  passwordValidator(form: UntypedFormGroup) {
    const condition = form.get('password').value !== form.get('confirm_password').value;

    return condition ? { passwordsDoNotMatch: true } : null;
  }
  passwordFormValidation() {
    if (this.signup_form.valid) {

      if (this.signup_form && this.signup_form.value && this.signup_form.value.password == this.signup_form.value.confirm_password) {

        return true;

      }
    }
    return false;
  }
  resendOTP() {
    this.timer = 60;
    let obj = this.login_form.value;
    var retrievedObject = jsonParse(localStorage.getItem('getipobject'));
    if (retrievedObject && retrievedObject.ip) {
      obj['ip'] = retrievedObject.ip;
    }
    let deviceInfo = this.device_detector_srv.getDeviceInfo();
    if (deviceInfo.device != 'Unknown') {
      let name = deviceInfo.device + ', ' + retrievedObject.city + ' (' + retrievedObject.region + ') ';
      obj['deviceName'] = name;
    }
    else {
      let name = deviceInfo.os_version + ', ' + retrievedObject.city + ' (' + retrievedObject.region + ') ';
      obj['deviceName'] = name;
    }
    if (this.valid_captcha_flag && this.login_form.value.loginId) {
      this.loginService.checkLogin(obj).subscribe(res => {
        if (res && res['status'] && res['data']) {
          let interval = setInterval(() => {
            this.timer--;
            if (this.timer < 1) {
              clearInterval(interval)
            }
          }, 1000)
          this.notification_svc.success(res['data'].topText, 'Close', 5000)
          this.otp_send = 1;
          this.login_form.controls.otp.setValidators([Validators.required]);
          this.login_form.controls.otp.updateValueAndValidity();
        }
        else {
          this.notification_svc.error(res['message'], 'Close', 5000)
          this.timer = 0;
        }
      }, err => {
        this.timer = 0;
      })

    }
    else {
      if (this.login_form.invalid) {
        getInvalidFields(this.login_form, this.translate, this.notification_svc, 'LOGIN.');
      }
      else if (!this.valid_captcha_flag) {
        this.notification_svc.error('ERROR.verify_captcha', 'Close', 5000)
      }
    }
  }
  ngOnInit() {
    this.init();
    this.loadMasters();
    this.addRecaptchaScript();
    this.callbackFuncRef = this.callbackFunc.bind(this);
    // this.sm_service.social_media.subscribe((res) => {
    //
    //   this.social_media = res;
    // })
    // this.loginService.getISD().subscribe(res => {
    //
    //   if (res['data']) {
    //     if (res['data'].isd.length) {
    //       this.isd = res['data'].isd;
    //       if (this.isd.length == 1) {
    //         this.selected_obj(this.isd[0]);
    //         //this.resume_referral.controls.mobile_no_cc.setValue(1000);
    //       }
    //     }
    //     if (res['data'].skill_code.length) {
    //       this.skill_code = res['data'].skill_code;
    //     }
    //   }
    // })
    // this.getDetails();
  }

  loadMasters() {
    this.profile_svc.loadDefaultSettings().subscribe(res => {
      if (res && res['data']) {
        if (res && res['data'] && res['data'].defaultConfig && res['data'].defaultConfig) {
          this.authType = res['data'].defaultConfig.authType;
          if (this.authType != 4) {
            this.login_form.controls.password.setValidators([Validators.required]);
            this.login_form.controls.password.updateValueAndValidity();
          }
          else {
            this.login_form.controls.password.clearValidators();
            this.login_form.controls.password.updateValueAndValidity();
            // this.login_form.controls.otp.setValidators([Validators.required]);
            // this.login_form.controls.otp.updateValueAndValidity();
          }
        }
        else {
          this.login_form.controls.password.setValidators([Validators.required]);
          this.login_form.controls.password.updateValueAndValidity();
        }
        this.field_config_access = prepareFieldConfigFlagsNew(res['data'].fieldConfigFlags, null, null, 'LOGIN_')
      }
    })
  }

  login(sid, oauth_version) {

    this.social_media.forEach(item => {
      if (item['portal_id'] == sid && oauth_version != '1') {
        if (!item['call_api']) {

          window.location.href = item.login_link;
        }
        // else if(oauth_version == '1'){
        //   this.loginService.loginTwitter(item['api_url'] || 'http://localhost:3000/').subscribe(res => {
        //
        //     window.location.href = `https://api.twitter.com/oauth/authorize?oauth_token=${res['token']}`;
        //   })
        // }
      }
      else if (oauth_version == '1') {
        this.loginService.oauthLoginV1(item['oauth1_token_api']).subscribe(res => {

          window.location.href = res['redirection_link'];
        })
      }
    })
  }

  loginWithUsernamePassword() {
    let obj = this.login_form.value;
    var retrievedObject = jsonParse(localStorage.getItem('getipobject'));
    if (retrievedObject && retrievedObject.ip) {
      obj['ip'] = retrievedObject.ip;
    }
    let deviceInfo = this.device_detector_srv.getDeviceInfo();
    if (deviceInfo.device != 'Unknown') {
      let name = deviceInfo.device + ', ' + retrievedObject.city + ' (' + retrievedObject.region + ') ';
      obj['deviceName'] = name;
    }
    else {
      let name = deviceInfo.os_version + ', ' + retrievedObject.city + ' (' + retrievedObject.region + ') ';
      obj['deviceName'] = name;
    }
    if ((this.valid_captcha_flag || this.otp_send) && this.login_form.valid) {
      if (this.authType == 4 && !this.otp_send) {

        this.loginService.checkLogin(obj).subscribe(res => {
          if (res && res['status'] && res['data']) {
            let interval = setInterval(() => {
              this.timer--;
              if (this.timer < 1) {
                clearInterval(interval)
                this.timer = 0;
              }
            }, 1000)
            this.notification_svc.success(res['data'].topText, 'Close', 5000)
            this.otp_send = 1;
            this.login_form.controls.otp.setValidators([Validators.required]);
            this.login_form.controls.otp.updateValueAndValidity();
          }
          else {
            this.timer = 0;
            this.notification_svc.error(res['message'], 'Close', 5000)
          }
        })
      }
      else {
        this.loginService.generateAccessToken(obj).subscribe(res => {
          if (res && res['data'] && res['data'].alreadyLoggedIn) {
            this.dialog
              .open(ConfirmationComponent, {
                width: "480px",
                height: "auto",
                panelClass: "icr-dialog",
                data: {
                  title: "ERROR.confirmation",
                  message: res['data'].message,
                  positive_button: "BTN.yes",
                  negative_button: "BTN.no"
                },
              })
              .afterClosed()
              .subscribe((modalRes) => {
                if (modalRes) {
                  obj['overwrite'] = 1
                  this.loginService.generateAccessToken(obj).subscribe(rAgain => {
                    this.loginService.firstLogin().subscribe(resp => {
                      if (resp && resp['status'] && resp['data'] && resp['data'].myJourney) {
                        this.router.navigate(['my-journey'])
                      }
                      else {
                        this.navigation(res)
                      }
                    }, err => {
                      this.navigation(res)
                    })
                  }, err => {
                    console.log(err);
                    this.notification_svc.error("Invalid Credentials", 'Close', 3000);
                  })
                }
              });
          }
          else if (res && res['status']) {
            this.loginService.firstLogin().subscribe(resp => {
              if (resp && resp['status'] && resp['data'] && resp['data'].myJourney) {
                this.router.navigate(['my-journey'])
              }
              else {
                this.navigation(res)
              }
            }, err => {
              this.navigation(res)
            })
          }
          else {
            this.notification_svc.error(res['message'], 'Close', 5000)
          }
        }, err => {
          console.log(err);
          this.notification_svc.error("Invalid Credentials", 'Close', 3000);

        })
      }

    }
    else {
      if (this.login_form.invalid) {
        markFormGroupTouched(this.login_form)
        getInvalidFields(this.login_form, this.translate, this.notification_svc, 'LOGIN.');
        if (this.authType == 4 && this.otp_send && this.login_form.value.loginId && !this.login_form.value.otp) {
          this.notification_svc.error('Please enter OTP to proceed', 'Close', 5000)
        }
      }
      else if (!this.valid_captcha_flag) {
        this.notification_svc.error('ERROR.verify_captcha', 'Close', 5000)
      }
    }

  }

  navigation(res?) {
    if (this.route.snapshot.queryParams.from) {
      this.dialogRef.close(res);
      this.router.navigate([this.route.snapshot.queryParams.from.replace(/%2F/g, '/')]);
    }
    else {
      if (this.router.url == '/jobs') {
        this.router.navigate(['/jobs/1']);
      }
      else if (this.router.url == '/jobs/1') {
        this.router.navigate(['/jobs']);
      }
      else {
        this.router.navigate(['/jobs']);
      }
      this.dialogRef.close(res);
    }
  }
  forgotPassword() {
    const dialog = this.dialog.open(ForgotPasswordComponent, {
      width: '40%',
      data: this.masters,
      panelClass: "TM-Dialog",
      disableClose: true

    });

    return dialog;
  }
  loginMessageChange(e) {
    this.error_message = "";
  }
  signUp(form_group) {
    if (form_group.valid) {
      if (this.signup_form.valid) {
        this.sign_up_details.setFormGroupData(this.signup_form.value);
        if (this.section_data && this.section_data.length) {
          let data_profile = Object.assign(this.sign_up_details, this.dynamic_form.get([this.section_data[0].section_id]).value);
          if (data_profile && data_profile.files && data_profile.files.length) {
            data_profile['files'] = data_profile.files[0];
          }
          if (data_profile && !data_profile.skill_code) {
            data_profile.skill_code = [];
          }
          this.loginService.signUp(data_profile).subscribe(res => {
            if (res['status'] == true) {
              if (this.route.snapshot.queryParams.from) {
                this._snackBar.open('Sign-up successfull');
                this.dialogRef.close(res['data']);
                this.router.navigate([this.route.snapshot.queryParams.from.replace(/%2F/g, '/')]);
              }
              else {
                this._snackBar.open('Sign-up successfull');
                // this.router.navigate(['/jobs']);
                //
                if (this.router.url == '/jobs') {
                  this.router.navigate(['/jobs/1']);
                }
                if (this.router.url == '/jobs/1') {
                  this.router.navigate(['/jobs']);
                }
                this.dialogRef.close(res['data']);
              }
            }
            else {
              this._snackBar.open(res['message']);
            }
            this.loading = 0;
          },
            err => {
              this.loading = 0;
              this.notification_svc.snackbar(err['message'], "Close", 3000)
            })

        }
      }
      else {
        this.markFormGroupTouched(this.signup_form);
        this.notification_svc.snackbar('Please fill manditory Fields', "Cancel", 3000);
      }
    }
    else {
      this.markFormGroupTouched(form_group);
      let invalid_controls = findInvalidControls(form_group, this.section_data[0], this.translate, this.notification_svc);
      this.markFormGroupTouched(this.signup_form);
    }
    // let code = this.sign_up_details.files;
    // if (this.signup_form.valid && this.passwordFormValidation() && code && code['file_title'] && code['status'] == 1) {
    //   setTimeout(function () {
    //     let shand = document.getElementsByClassName('document') as HTMLCollectionOf<HTMLElement>;
    //     if (shand.length != 0) {
    //       shand[0].style.color = 'rgb(138, 138, 138)';
    //     }
    //   });
    //   this.message = "";
    //   this.loading = 1;
    //   this.sign_up_details.setFormGroupData(this.signup_form.value);
    //
    //   this.loginService.signUp(this.sign_up_details).subscribe(res => {
    //     if (res['status'] == true) {
    //       if (this.route.snapshot.queryParams.from) {
    //         this._snackBar.open('Sign-up successfull');
    //         this.dialogRef.close(res['data']);
    //         this.router.navigate([this.route.snapshot.queryParams.from.replace(/%2F/g, '/')]);
    //       }
    //       else {
    //         this._snackBar.open('Sign-up successfull');
    //         this.dialogRef.close(res['data']);
    //       }
    //     }
    //     else if (res['code'] == 200 && res['status'] == false) {
    //       this._snackBar.open(res['message']);
    //     }
    //     this.loading = 0;
    //   },
    //     err => {
    //       this.loading = 0;
    //     })
    // }
    // else if (!code || code['status'] == 2 || !code['file_title']) {
    //   this._snackBar.open('Please upload your resume');
    //   // document.getElementsByClassName('document').
    //   setTimeout(function () {
    //     let shand = document.getElementsByClassName('document') as HTMLCollectionOf<HTMLElement>;
    //     if (shand.length != 0) {
    //       shand[0].style.color = 'red';
    //     }
    //   });
    // }
    // else if (this.signup_form.invalid) {
    //   setTimeout(function () {
    //     let shand = document.getElementsByClassName('document') as HTMLCollectionOf<HTMLElement>;
    //     if (shand.length != 0) {
    //       shand[0].style.color = 'rgb(138, 138, 138)';
    //     }
    //   });
    //   this._snackBar.open('Please fill all the required fields')
    // }
  }
  messageChange(e) {
    this.message = "";
  }
  signUpForm() {
    console.log(this.data)
    if (this.data && this.data.queryParams) {
      this.router.navigate(['reg'], {
        queryParams: this.data && this.data.queryParams
      });
    }
    else {
      this.router.navigate(['registration'])
    }

    this.dialogRef.close();
    // this.form_flag = 2;
    this.message = "";
    this.search = "";
    // this.login_form.reset();

  }
  LoginForm() {
    this.form_flag = 1;
    this.error_message = "";
    this.search = "";
    this.signup_form.reset();
  }
  cancel() {
    this.dialogRef.close(null);
  }
  public file_doc: any;
  base64;
  file_title;
  mime_type;
  // saveFileResult(ev) {
  //   this.sign_up_details.files = (ev.files[0]);
  //   if (this.sign_up_details && (!this.sign_up_details.files || !this.sign_up_details.files['file_title'])) {
  //     setTimeout(function () {
  //       let shand = document.getElementsByClassName('document') as HTMLCollectionOf<HTMLElement>;
  //       if (shand.length != 0) {
  //         shand[0].style.color = 'red';
  //       }
  //     });

  //   }
  //   if (this.sign_up_details && this.sign_up_details.files && this.sign_up_details.files['status'] == 2) {
  //     setTimeout(function () {
  //       let shand = document.getElementsByClassName('document') as HTMLCollectionOf<HTMLElement>;
  //       if (shand.length != 0) {
  //         shand[0].style.color = 'red';
  //       }
  //     });
  //   }
  //   if (ev && ev.files && ev.files[0]) {
  //     this.base64 = (ev.files[0].content);
  //     this.file_title = (ev.files[0].file_title);
  //     this.mime_type = (ev.files[0].mime_type);
  //   }
  //   function dataURLtoFile(dataurl, filename) {
  //     if (dataurl) {
  //       var arr = dataurl.split(','),
  //         mime = arr[0].match(/:(.*?);/)[1],
  //         bstr = atob(arr[1]),
  //         n = bstr.length,
  //         u8arr = new Uint8Array(n);
  //       while (n--) {
  //         u8arr[n] = bstr.charCodeAt(n);
  //       }

  //       return new File([u8arr], filename, { type: mime });
  //     }
  //   }
  //   let file = dataURLtoFile(this.base64, this.file_title);
  //   this.file_doc = file;

  //   if (this.sign_up_details.files && this.sign_up_details.files['file_title'] && this.sign_up_details.files['status'] != 2) {
  //     setTimeout(function () {
  //       let shand = document.getElementsByClassName('document') as HTMLCollectionOf<HTMLElement>;
  //       if (shand.length != 0) {
  //         shand[0].style.color = 'rgb(138, 138, 138)';
  //       }
  //     });
  //     this.length_file = 1;
  //     this.saveFile();
  //   }

  // }
  // saveFile() {
  //   let input = new FormData();
  //   if (this.file_doc && this.file_doc.name) {
  //     // Add your values in here
  //     input.append('attachment', this.file_doc, this.file_doc.name);
  //     this.loader.showLoader();
  //     this.loginService.saveFile(input).subscribe(res => {
  //
  //       this.sign_up_details.setFormGroupData(this.signup_form.value);
  //       this.sign_up_details.setFile(res['Document']);
  //       this.signup_form.setValue(this.sign_up_details.getFormGroupData());
  //     })
  //   }
  // }
  inputText(event: KeyboardEvent, max) {
    var input = <HTMLInputElement>event.srcElement;
    let charCode = (event.which) ? event.which : event.keyCode;
    try {
      if (charCode == 8 || charCode == 9) {
        return true;
      }
      if (input.value.length === 0 && event.keyCode === 32 || input.value.length >= max) {
        return false;
      }
      if ((charCode > 64 && charCode < 91) || event.keyCode === 32) {
        return true;
      }
      else {
        return false;
      }
    }
    catch (error) {

    }
  }
  inputTextMaxNull(event: KeyboardEvent) {
    var input = <HTMLInputElement>event.srcElement;
    let charCode = (event.which) ? event.which : event.keyCode;
    try {
      if (charCode == 8 || charCode == 9) {
        return true;
      }
      if (input.value.length === 0 && event.keyCode === 32) {
        return false;
      }
      if ((charCode > 64 && charCode < 91) || event.keyCode === 32) {
        return true;
      }
      else {
        return false;
      }
    }
    catch (error) {

    }
  }
  inputNumber(evt: KeyboardEvent) {
    let input = <HTMLInputElement>event.srcElement;
    let charCode = (evt.which) ? evt.which : evt.keyCode;
    try {
      if (charCode == 13) {
        return false;
      }
      if (charCode == 8 || charCode == 9) {
        return true;
      }
      if (input.value.length == 0) {
        if (charCode == 96 || charCode == 48) {
          return false
        }
        else if (charCode < 31 || (charCode >= 48 && charCode <= 57) || (charCode >= 96 && charCode <= 105)) {
          return true;
        }
        else {
          return false;
        }
      }
      else if (input.value.length >= this.mobile_number_length) {
        return false;
      }
      else if (input.value.length < this.mobile_number_length) {
        if (charCode < 31 || (charCode >= 48 && charCode <= 57) || (charCode >= 96 && charCode <= 105)) {
          return true;
        }
        else {
          return false;
        }
      }

    }
    catch (error) {

    }
  }
  mobile_number_length = 10;
  min_value;
  max_value;
  mobileLength(e) {
    try {
      if (e && this.isd && this.isd.length) {
        for (let i = 0; i < this.isd.length; i++) {
          if (e == this.isd[i].isd_code) {
            if (this.isd[i].mobile_number_length) {
              this.mobile_number_length = this.isd[i].mobile_number_length;
            }
          }
        }
        this.min_value = '1';
        this.max_value = '9';
        for (let i = 0; i < this.mobile_number_length - 1; i++) {
          this.min_value = this.min_value + '0';
        }
        for (let i = 0; i < this.mobile_number_length - 1; i++) {
          this.max_value = this.max_value + '9';
        }
        this.signup_form.controls.mobile_no.setValidators([Validators.required, Validators.min(parseInt(this.min_value)), Validators.max(parseInt(this.max_value))]);
      }
    }
    catch (error) {

    }
  }

  inputEmail(event: KeyboardEvent) {
    let input = <HTMLInputElement>event.srcElement;
    let charCode = (event.which) ? event.which : event.keyCode;

    if (charCode === 20) {
      return false;
    }
    try {
      if (event.keyCode === 32) {
        return false;
      }
    }
    catch (error) {

    }
  }
  selected_obj(e) {
    try {
      if (e && e.isd_code) {
        this.mobileLength(e.isd_code);
      }
    }
    catch (e) {

    }
  }
  onResetPassword(form) {
    this.isLoaded = true;
    this.userId = form.value.userId;

    if (this.userId == "") {

      this.invalid = true;


    }
    else {
      this.invalid = false;
    }
    if (!this.isOTPSendSuccessfully) {
      this.loginService.forgotPassword(this.userId).subscribe(resData => {

        if (resData['status'] == true) {
          this.isOTPSendSuccessfully = true;

          this.isLinkSendSuccessfully = false;
          this.isLoaded = false;
        }
        else {


        }

      },
        errorData => {

        }

      );
    }
    else {

    }
  }
  save() {
    if (this.password_form.invalid) {
      this._snackBar.open('Email ID is required');
    }
    else {
      this.invalid = false;

      this.loginService.forgotPassword(this.password_form.value.login_id).subscribe(resData => {

        if (resData['status'] == true) {
          this.isOTPSendSuccessfully = true;


        }
      });
    }
  }
  getDetails(flag?) {
    this.loginService.getFormDetails({ form_code: 7005, t_id: 0, template_code: 9998, lng_id: 1 }).subscribe(res => {
      if (res && res['data'] && res['data']['details'] && res['data']['details'].length) {
        res['data']['details'][0].editable = true;
        res['data']['details'][0].edit_flag = true;
        this.section_data = res['data']['details'];

        if (res['data']['details'][0]) {
          this.display_type = res['data']['details'][0].display_type_id;
        }
      }
      else {
        this.notification_svc.snackbar(res['message'], 'Close', 5000);
      }
    })
    if (!flag) {
      this.loginService.getFormMaster({ form_code: 7005, t_id: 0, template_code: 9998, lng_id: 1 }).subscribe(masters => {
        this.masters = masters['data'].masters;
        this.change_detector.detectChanges();
      })
    }

  }
  markFormGroupTouched(formGroup: UntypedFormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      control.markAsDirty();
      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }
  findInvalidControls(form_group) {
    const invalid = [];
    const controls = form_group.controls;
    if (controls && Object.keys(controls)) {
      for (const name in controls) {
        try {
          if (controls[name].invalid) {
            invalid.push(name);
          }
        } catch (err) {

        }
      }
    }

    return invalid;
  }
  callbackFunc(func, ev) {

    eval('this.' + func);
  }
  parseResume(ev) {

    if (this.dynamic_form.dirty) {
      const dialogConfig = new MatDialogConfig()
      dialogConfig.width = "25%";
      dialogConfig.data = {
        title: "Confirmation",
        message: "Existing data will be replaced by the data parsed from resume document. Are you sure ?",
        positive_button: "Proceed",
        negative_button: "Cancel"
      };
      let ref = this.dialog.open(ConfirmationComponentCopy, dialogConfig);


      ref.afterClosed().subscribe(res => {
        if (res) {
          if (ev) {
            this.parseResumeDocument(ev);
          }
        }
      })
    }
    else {
      this.parseResumeDocument(ev);
    }
  }
  parser(section) {
    for (let i = 0; i < section.length; i++) {
      if (section[i] && section[i].data && typeof section[i].data == 'string') {
        while (typeof section[i].data != 'object') {
          section[i].data = jsonParse(section[i].data);
          // section[i].data.forEach(){

          // }
          for (let j = 0; j < section[i].data.length; j++) {
            let section_data = jsonParse(section[i].data[j]);
            if (section[i].multiple && !(section_data.t_id || section_data.random_id)) {
              section_data.random_id = Math.floor(Date.now() + Math.random() * 1000);
            }
          }
        }
      }
      if (section[i] && section[i].sections && typeof section[i].sections == 'string') {
        while (typeof section[i].sections != 'object') {
          section[i].sections = jsonParse(section[i].sections);


          if (section[i] && section[i].sections) {
            this.parser(section[i].sections);
          }
        }
      }
    }
    return section;
    // else {
    //   return section;
    // }
  }
  prepareSectionParsedData(sections, form, section_data, parsed_resume?, parent_form?) {
    sections = jsonParse(sections);
    if (sections && typeof sections == 'object') {
      for (let ind = 0; ind < sections.length; ind++) {

        if (parsed_resume && parsed_resume[ind] && parsed_resume[ind].data && section_data[ind].active_section) {
          sections[ind].data = cloneArray(jsonParse(parsed_resume[ind].data));
          // parsed_resume[ind].data = null;
        }
        else {
          sections[ind].data = jsonParse(sections[ind].data);
        }

        section_data[ind].data = jsonParse(sections[ind].data);

        if (sections[ind].data && !sections[ind].multiple) {
          if (sections[ind].data[0]) {
            if (sections[ind].field_details && typeof sections[ind].field_details == 'object' && sections[ind].field_details.length) {
              let fields = sections[ind].field_details;
              if (fields) {
                fields.forEach(field => {
                  if (field.control_type_id == 8) {

                    sections[ind].data[0][field.field_name] = jsonParse(sections[ind].data[0][field.field_name]);
                  }
                });
              }
            }
            if (form) {
              let section_form = form.get([sections[ind].section_id]);
              section_form.patchValue(sections[ind].data[0]);
            }
          }
        }
        else if (sections[ind].multiple) {

          parent_form.get([sections[ind].section_id]).patchValue(sections[ind].data);
        }

        if (parsed_resume && parsed_resume[ind] && parsed_resume[ind].data && section_data[ind].active_section) {
          parsed_resume[ind].data = null;
        }
        // form.addControl(sections[ind].section_id, section_form);

        if (section_data[ind].grid_layout) {
          section_data[ind].grid_layout = jsonParse(sections[ind].grid_layout);
        }

        sections[ind].sections = jsonParse(sections[ind].sections);
        if (sections[ind].sections && sections[ind].sections.length) {
          try {
            if (sections[ind].multiple) {
              this.prepareSectionParsedData(sections[ind].sections, sections[ind].multiple_form, section_data[ind].sections, parsed_resume[ind].sections, form.get([sections[ind].section_id]));
            }
            else {
              this.prepareSectionParsedData(sections[ind].sections, form.get([sections[ind].section_id]), section_data[ind].sections, parsed_resume[ind].sections, form.get([sections[ind].section_id]));

            }
          }
          catch (err) {

          }
        }
      }
    }
  }
  duplicate_resume_grid;
  parseResumeDocument(ev) {
    this.workbench_svc.parseResumeDetails({ resume_document: ev }, 7005, 0).subscribe(res => {

      if (res && res['data'] && res['data'].details && res['data'].details.length) {
        this.parsed_resume = this.parser(res['data'].details);
        this.prepareSectionParsedData(this.parser(res['data'].details), this.dynamic_form, this.section_data, this.parsed_resume, this.dynamic_form);
        checkActiveSection(this.section_data, this.display_type);

        this.change_detector.detectChanges();

        try {
          if (res['data'].duplicate_details && Object.keys(res['data'].duplicate_details) && Object.keys(res['data'].duplicate_details).length) {
            this.duplicate_resume_grid = jsonParse(res['data'].duplicate_details);
            this.notification_svc.snackbar("Resume already exists", "Close", 3000);
          }
        }
        catch (err) {

        }
      }
    })
  }
  addRecaptchaScript() {

    window['grecaptchaCallback'] = () => {
      this.renderReCaptch();
    }

    (function (d, s, id, obj) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) { obj.renderReCaptch(); return; }
      js = d.createElement(s); js.id = id;
      js.src = "https://www.google.com/recaptcha/api.js?onload=grecaptchaCallback&amp;render=explicit";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'recaptcha-jssdk', this));
  }
  renderReCaptch() {
    try {
      window['grecaptcha'].render('tm-recaptcha', {
        'sitekey': environment.RECAPCHA_KEY,
        'callback': (response) => {
          this.valid_captcha = response;
          this.valid_captcha_flag = true;
          this.change_detector.detectChanges();
        },
        'expired-callback': (response) => {
          this.expiredCallback();
        },
      });
    }
    catch (err) {
      try {
        setTimeout(() => {
          window['grecaptcha'].render('tm-recaptcha', {
            'sitekey': environment.RECAPCHA_KEY,
            'callback': (response) => {
              this.valid_captcha = response;
              this.valid_captcha_flag = true;
              this.change_detector.detectChanges();
            },
            'expired-callback': (response) => {
              this.expiredCallback();
            },
          });
        }, 200)
      }
      catch (err) {
        setTimeout(() => {
          window['grecaptcha'].render('tm-recaptcha' || this.captch_element && this.captch_element.nativeElement, {
            'sitekey': environment.RECAPCHA_KEY,
            'callback': (response) => {
              this.valid_captcha = response;
              this.valid_captcha_flag = true;
              this.change_detector.detectChanges();
            },
            'expired-callback': (response) => {
              this.expiredCallback();
            },
          });
        }, 200)
      }
    }

  }
  expiredCallback() {
    this.valid_captcha = "";
    this.valid_captcha_flag = false
    this.change_detector.detectChanges();

  }
}



